import React from 'react';
import './Tabs.css';
const Tabs = ({handleTabSelected, tabs}) => {
  return (
    <div className='tabs'>
      <div className='tabs__wrapper'>
        <div className='tabs__buttons-list'>
          {tabs.map((item) => (
            <div
              data-id={item.id}
              onClick={handleTabSelected}
              key={item.id}
              className={`tabs__item ${item.active ? 'tabs__item_active' : ''}`}
            >
              <span
                className={`tabs__item-link ${
                  item.active ? 'tabs__item-link_active' : ''
                }`}
              >
                <span
                  className={`tabs__item-text ${
                    item.active ? 'tabs__item-text_active' : ''
                  }`}
                >
                  {item.value}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
